import AppConfig from "../Configuration/AppConfig";
import { ApplicationPaths} from './ApiAuthorizationConstants';

let { AppBaseUrl } = AppConfig.Network;
let { clientId, apiAllowedScope, authorizeUrl } = AppConfig.AzureAd;

export const IDENTITY_CONFIG = {
  authority: authorizeUrl, //(string): The URL of the OIDC provider.
  client_id: clientId, //(string): Your client application's identifier as registered with the OIDC provider.
  redirect_uri: `${AppBaseUrl}${ApplicationPaths.LoginCallback}`, //The URI of your client application to receive a response from the OIDC provider.
  login: authorizeUrl + "/login",
  automaticSilentRenew: true, //(boolean, default: false): Flag to indicate if there should be an automatic attempt to renew the access token prior to its expiration.
  loadUserInfo: false, //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
  silent_redirect_uri: `${AppBaseUrl}${ApplicationPaths.LoginCallback}`, //(string): The URL for the page containing the code handling the silent renew.
  post_logout_redirect_uri: `${AppBaseUrl}${ApplicationPaths.LogOutCallback}`, // (string): The OIDC post-logout redirect URI.
  audience: '', //is there a way to specific the audience when making the jwt
  response_type: "id_token token", //(string, default: 'id_token'): The type of response desired from the OIDC provider.
  grantType: "implicit",
  scope: `openid email profile ${apiAllowedScope} `, //(string, default: 'openid'): The scope being requested from the OIDC provider.
  webAuthResponseType: "id_token token"
};
